import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../lib/shared/validators";
import { customFieldValues } from "../custom_fields";

export const serviceStatus = v.union(
  v.literal("active"),
  v.literal("inactive"),
  v.literal("discontinued"),
);

export const validatorService = v.object({
  internalControl,

  name: v.string(),
  description: v.optional(v.string()),
  code: v.optional(v.string()),
  sku: v.optional(v.string()),

  unitPrice: v.number(),
  currency: v.optional(v.string()),

  categoryId: v.optional(v.id("categories")),
  categories: v.optional(v.array(v.id("categories"))),
  brandId: v.optional(v.id("brands")),

  unit: v.optional(v.string()),

  taxRate: v.optional(v.number()),
  taxIncluded: v.optional(v.boolean()),
  isExempt: v.optional(v.boolean()),
  exemptRate: v.optional(v.number()),
  exemptAmount: v.optional(v.number()),

  discountRate: v.optional(v.number()),
  discountAmount: v.optional(v.number()),

  status: v.optional(serviceStatus),

  estimatedDuration: v.optional(v.number()),
  estimatedDurationUnit: v.optional(v.string()),

  imageId: v.optional(v.id("_storage")),
  imageIds: v.optional(v.array(v.id("_storage"))),

  notes: v.optional(v.string()),
  tags: v.optional(v.array(v.string())),

  /** Valores de campos personalizados (Colecciones), por key de definición. */
  customFields: v.optional(customFieldValues),
});

export const services = defineTable(validatorService)
  .index("by_status", ["status"])
  .index("by_code", ["code"])
  .index("by_company_and_code", ["internalControl.companyId", "code"])
  .index("by_company_and_brand", ["internalControl.companyId", "brandId"])
  .index("by_category", ["categoryId"])
  .index("by_categories", ["categories"])
  .index("by_company_and_category", [
    "internalControl.companyId",
    "categoryId",
  ])
  .index("by_company_and_status", [
    "internalControl.companyId",
    "status",
  ])
  .index("by_branch_and_status", [
    "internalControl.branchId",
    "status",
  ])
  .index("by_company_id", ["internalControl.companyId"])
  .index("by_branch_id", ["internalControl.branchId"])
  .index("by_state", ["internalControl.state"])
  .index("by_company_and_state", [
    "internalControl.companyId",
    "internalControl.state",
  ])
  .index("by_branch_and_state", [
    "internalControl.branchId",
    "internalControl.state",
  ])
  .index("by_company_and_branch", [
    "internalControl.companyId",
    "internalControl.branchId",
  ])
  .index("by_created_by", ["internalControl.createdBy"])
  .index("by_updated_by", ["internalControl.updatedBy"])
  .index("by_created_at", ["internalControl.createdAt"])
  .index("by_company_and_created_at", [
    "internalControl.companyId",
    "internalControl.createdAt",
  ]);
